// DO NOT EDIT -- generated from fs/services/pie/stress_test.proto

import * as protobuf from '../../../google/protobuf';

export namespace StressTestAdmin {

  export const PostgresVectorStressTestEndpoint = "/grpc/pie.StressTestAdmin/PostgresVectorStressTest";
  export function PostgresVectorStressTest(sender: (req: PostgresVectorStressTestRequest, endpoint: string) => Promise<PostgresVectorStressTestResponse>, req: PostgresVectorStressTestRequest): { promise: () => Promise<PostgresVectorStressTestResponse>, endpoint: string } {
    return {
      promise: () => sender(req, PostgresVectorStressTestEndpoint),
      endpoint: PostgresVectorStressTestEndpoint
    };
  }

  export const ClearPostgresVectorStressTestDataEndpoint = "/grpc/pie.StressTestAdmin/ClearPostgresVectorStressTestData";
  /** Forces a clear of test table. Shouldn't need this since we clear it after a test run but just in caes. */
  export function ClearPostgresVectorStressTestData(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, ClearPostgresVectorStressTestDataEndpoint),
      endpoint: ClearPostgresVectorStressTestDataEndpoint
    };
  }
}

export enum VectorQueryType {
  VECTOR_QUERY_TYPE_UNKNOWN = 0,
  VECTOR_QUERY_TYPE_L1 = 1,
  VECTOR_QUERY_TYPE_L2 = 2,
  VECTOR_QUERY_TYPE_INNER_PRODUCT = 3,
  VECTOR_QUERY_TYPE_COSINE = 4
}

export enum VectorIndexType {
  VECTOR_INDEX_TYPE_UNKNOWN = 0,
  VECTOR_INDEX_TYPE_L1 = 1,
  VECTOR_INDEX_TYPE_L2 = 2,
  VECTOR_INDEX_TYPE_INNER_PRODUCT = 3,
  VECTOR_INDEX_TYPE_COSINE = 4,
  VECTOR_INDEX_TYPE_NO_INDEX = 5
}

export interface PostgresVectorStressTestRequest {
  indexTestTypes?: PostgresVectorStressTestRequest.IndexTestTypes | null;
  allTests?: boolean;
  /** How many rows to insert into each row */
  numEmbeddings: number;
  /** The number of queries to perform total */
  numQueries: number;
  /** The number of related vectors to search for each query */
  numRelatedVectorsPerQuery: number;
}

export namespace PostgresVectorStressTestRequest {
  export interface IndexTestTypes {
    noIndexTest: boolean;
    l1Test: boolean;
    l2Test: boolean;
    ipTest: boolean;
    cosineTest: boolean;
  }

  export enum tests_to_run {
    indexTestTypes = 6,
    allTests = 7
  }

  export function tests_to_run_oneof(m: PostgresVectorStressTestRequest): { opt: tests_to_run.allTests, val: boolean } | { opt: tests_to_run.indexTestTypes, val: PostgresVectorStressTestRequest.IndexTestTypes } | null {
    if (m.indexTestTypes != null) { return { opt: tests_to_run.indexTestTypes, val: m.indexTestTypes } }
    if (m.allTests != null) { return { opt: tests_to_run.allTests, val: m.allTests } }
    return null;
  }
}

export interface PostgresVectorStressTestResponse {
  results: PostgresVectorStressTestResponse.Results[];
}

export namespace PostgresVectorStressTestResponse {
  export interface QueryTypeResults {
    queryType: VectorQueryType;
    totalQueryTime: protobuf.duration | null;
  }

  export interface Results {
    insertTime: protobuf.duration | null;
    /** float queried_average_distance = 4; */
    indexType: VectorIndexType;
    queryTypeResults: PostgresVectorStressTestResponse.QueryTypeResults[];
  }
}
